// services/TutorialService.js
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  serverTimestamp
} from 'firebase/firestore'
import { app } from '../firebase'
import UserService from './UserService'

class TutorialService {
  constructor () {
    this.db = getFirestore(app)
  }

  /**
   * Lädt Tutorial-Präferenzen für einen User
   * @param {string} userId - Firebase Auth UID
   * @param {string} companyId - Company ID
   * @returns {Promise<Object|null>} Tutorial-Präferenzen oder null
   */
  async getTutorialPreferences (userId, companyId) {
    try {
      if (!userId || !companyId) {
        return null
      }

      const prefRef = doc(
        this.db,
        'companies',
        companyId,
        'tutorialPreferences',
        userId
      )

      const docSnap = await getDoc(prefRef)

      if (docSnap.exists()) {
        const data = docSnap.data()
        return {
          hasSeenPrompt: data.hasSeenPrompt || false,
          hasCompletedTutorial: data.hasCompletedTutorial || false,
          dismissedAt: data.dismissedAt?.toDate?.() || data.dismissedAt || null,
          completedAt: data.completedAt?.toDate?.() || data.completedAt || null
        }
      }

      // Keine Präferenzen vorhanden - User ist neu
      return {
        hasSeenPrompt: false,
        hasCompletedTutorial: false,
        dismissedAt: null,
        completedAt: null
      }
    } catch (error) {
      console.error('Error loading tutorial preferences:', error)
      return null
    }
  }

  /**
   * Markiert den Tutorial-Prompt als "Nicht mehr anzeigen"
   * @param {string} userId - Firebase Auth UID
   * @param {string} companyId - Company ID
   */
  async dismissTutorialPrompt (userId, companyId) {
    try {
      if (!userId || !companyId) {
        throw new Error('userId und companyId sind erforderlich')
      }

      const prefRef = doc(
        this.db,
        'companies',
        companyId,
        'tutorialPreferences',
        userId
      )

      await setDoc(
        prefRef,
        {
          hasSeenPrompt: true,
          dismissedAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        },
        { merge: true }
      )
    } catch (error) {
      console.error('Error dismissing tutorial prompt:', error)
      throw error
    }
  }

  /**
   * Markiert das Tutorial als abgeschlossen
   * @param {string} userId - Firebase Auth UID
   * @param {string} companyId - Company ID
   */
  async markTutorialCompleted (userId, companyId) {
    try {
      if (!userId || !companyId) {
        throw new Error('userId und companyId sind erforderlich')
      }

      const prefRef = doc(
        this.db,
        'companies',
        companyId,
        'tutorialPreferences',
        userId
      )

      await setDoc(
        prefRef,
        {
          hasCompletedTutorial: true,
          completedAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        },
        { merge: true }
      )
    } catch (error) {
      console.error('Error marking tutorial as completed:', error)
      throw error
    }
  }
}

export default new TutorialService()

